import { takeLatest, put, call, take } from 'redux-saga/effects';
import camelCase from 'lodash/camelCase';

import {
  DOCUMENTATION_TYPES,
  INSURANCE_CARD_SIDE,
  RECORD_TYPE,
} from '../../../constants';
import { INSURANCES_CARD_KEYS_MAPPER } from '../../../constants/insurance/insurance-card-keys-mapper';
import { INITIAL_INSURANCE_CARD_STATE } from '../../../constants/insurance/initial-insurance-card-state';

import { checkInsuranceCardOcr } from './check-insurance-card-ocr';
import { actions as deleteUserDocumentsActions } from '../../profiles/delete-user-documents';
import {
  MANAGE_INSURANCES_ACTION_TYPES,
  manageInsurancesActions,
} from '../actions/manage-insurances-actions';
import {
  actions as uploadUserDocumentsActions,
  consts as uploadUserDocumentsConsts,
} from '../../profiles/upload-user-documents';

function* uploadMainInsuranceCardWorker({ payload }) {
  const { fieldName, imgValue, imgId, userId, handleFormChange } = payload;

  const { deleted = false, file = '' } = { ...imgValue };

  const isCardFrontSide = fieldName === DOCUMENTATION_TYPES.CARD_1;

  const formStateCardKey = isCardFrontSide
    ? INSURANCE_CARD_SIDE.FRONT
    : INSURANCE_CARD_SIDE.BACK;

  const camelCasedKey = camelCase(formStateCardKey);

  const data = new FormData();
  data.append('attachment', file);
  data.append('userId', userId);

  if (deleted && imgId) {
    yield put(deleteUserDocumentsActions.send({ userId, id: imgId }));

    handleFormChange({ [camelCasedKey]: INITIAL_INSURANCE_CARD_STATE });
  }

  if (file && !imgId) {
    yield put(
      manageInsurancesActions.setUploadInsuranceCardModalData({
        isOpened: true,
        cardType: INSURANCES_CARD_KEYS_MAPPER.get(formStateCardKey),
      }),
    );

    data.append('key', fieldName);

    yield put(uploadUserDocumentsActions.send(data));

    const result = yield take(uploadUserDocumentsConsts.SUCCEED);

    const { payload: resultPayload } = result;

    if (isCardFrontSide) {
      yield call(checkInsuranceCardOcr, {
        recordId: resultPayload.id,
        userId,
        handleFormChange,
        recordType: RECORD_TYPE.DOCUMENT,
      });
    }
  }

  yield put(
    manageInsurancesActions.setUploadInsuranceCardModalData({
      isOpened: false,
      cardType: null,
    }),
  );
}

export function* uploadMainInsuranceCard() {
  yield takeLatest(
    MANAGE_INSURANCES_ACTION_TYPES.UPLOAD_MAIN_INSURANCE_CARD,
    uploadMainInsuranceCardWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/upload-main-insurance-card.js